import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Link, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

import { InboxFragment, useMarkInboxAsReadMutation } from 'api';
import { Notifications as NotificationsLink } from 'Links';
import { EmptyState } from 'components';
import { useNotify } from 'hooks';

import { useMarkInboxAsRead } from '../updaters';
import Notification from '../components/Notification';

interface IProps {
  inbox: InboxFragment[];
  onClick(): void;
}

const useStyles = makeStyles(theme => ({
  menu: {
    width: 300,
  },
  common: {
    padding: '12px 24px',
    outline: 'none',
  },
  header: {
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
  },
  footer: {
    borderTop: `1px solid ${theme.palette.grey[300]}`,
  },
}));

const NotificationsPopup: FC<IProps> = ({ onClick, inbox }) => {
  const classes = useStyles();
  const notify = useNotify();
  const { t } = useTranslation();

  const mutationOptions = useMarkInboxAsRead();
  const { mutate: markInboxAsRead } = useMarkInboxAsReadMutation({
    onError: notify.mutationError,
    ...mutationOptions,
  });

  function renderHeader() {
    const headerClasses = classNames(classes.common, classes.header);

    return (
      <div className={headerClasses}>
        <Grid container alignItems="center" justify="space-around">
          <Grid item xs>
            <Typography variant="subtitle2">{t('common:notification_plural')}</Typography>
          </Grid>
          <Grid item>
            <Link component="button" onClick={() => markInboxAsRead({})}>
              {t('components:markRead')}
            </Link>
          </Grid>
        </Grid>
      </div>
    );
  }

  function renderFooter() {
    const footerClasses = classNames(classes.common, classes.footer);

    return (
      <div className={footerClasses}>
        <Grid container alignItems="center" justify="space-around">
          <Grid item>
            <Link component={NotificationsLink} onClick={onClick}>
              {t('components:seeAll')}
            </Link>
          </Grid>
        </Grid>
      </div>
    );
  }

  return (
    <Fragment>
      {renderHeader()}
      {!inbox.length && <EmptyState fullWidth name="notificationPop" />}
      {inbox.map(item => (
        <Notification onClick={onClick} key={item.id} size="regular" item={item} />
      ))}
      {renderFooter()}
    </Fragment>
  );
};

export default NotificationsPopup;
